import { render, staticRenderFns } from "./ticketStatus.vue?vue&type=template&id=c771025c"
import script from "./ticketStatus.vue?vue&type=script&lang=js"
export * from "./ticketStatus.vue?vue&type=script&lang=js"
import style0 from "./ticketStatus.vue?vue&type=style&index=0&id=c771025c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports